import React from 'react';
import { Box } from '@mui/material';
import { IPD_COLORS, ipdCardSx } from './ipdColors';
import { thinScrollbarSx } from './ipdScrollbar';

/** Pill-style tab bar used across IPD-suite pages (store detail, consumption, etc.). */
export default function IpdTabBar({ tabs, activeTab, onChange, ariaLabel, sx }) {
  return (
    <Box
      sx={{
        ...ipdCardSx,
        color: IPD_COLORS.textPrimary,
        mb: 2,
        display: 'flex',
        gap: 0.5,
        px: 1,
        py: 0.75,
        overflowX: 'auto',
        ...thinScrollbarSx,
        ...sx,
      }}
      role="tablist"
      aria-label={ariaLabel}
    >
      {tabs.map(tab => {
        const active = activeTab === tab.id;
        return (
          <Box
            key={tab.id}
            component="button"
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.id)}
            sx={{
              border: 'none',
              cursor: 'pointer',
              px: 1.75,
              py: 0.75,
              borderRadius: '8px',
              whiteSpace: 'nowrap',
              fontSize: 13,
              fontWeight: active ? 600 : 500,
              fontFamily: 'inherit',
              color: active ? IPD_COLORS.primary : IPD_COLORS.textSecondary,
              backgroundColor: active ? IPD_COLORS.selectedBg : 'transparent',
              transition: 'all 0.15s ease',
              '&:hover': {
                color: IPD_COLORS.primary,
                backgroundColor: active ? IPD_COLORS.selectedBg : 'rgba(13,35,63,0.04)',
              },
              '&:focus-visible': {
                outline: `2px solid ${IPD_COLORS.primary}`,
                outlineOffset: 2,
              },
            }}
          >
            {tab.label}
          </Box>
        );
      })}
    </Box>
  );
}
